<template>
  <div v-if="currentRemplacement">
    <div class="mt-4 mb-4">
      <div class="row d-flex justify-content-center">
        <div class="col-md-9 mr-md-3 bg-white">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr class="d-flex justify-content-between">
                  <td>
                    <i class="fa fa-user text-custom-primary"></i>
                    <span class="font-weight-bold ml-1">Employé</span>
                  </td>
                  <td>
                    <a
                      style="cursor: pointer"
                      title="Aperçu employé"
                      @click="viewEmploye(currentRemplacement.employe_id)"
                      >{{ currentRemplacement.employe }}
                      <i class="fa fa-eye ml-2"></i
                    ></a>
                  </td>
                </tr>
                <tr class="d-flex justify-content-between">
                  <td>
                    <i class="fa fa-user text-custom-primary"></i>
                    <span class="font-weight-bold ml-1">Remplaçant</span>
                  </td>
                  <td>
                    <a
                      v-if="currentRemplacement.remplacant_id"
                      style="cursor: pointer"
                      title="Aperçu employé"
                      @click="viewEmploye(currentRemplacement.remplacant_id)"
                      >{{ currentRemplacement.remplacant }}
                      <i class="fa fa-eye ml-2"></i
                    ></a>
                    <span v-else>{{ currentRemplacement.remplacant }}</span>
                  </td>
                </tr>
                <tr class="d-flex justify-content-between">
                  <td>
                    <i class="fa fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date début</span>
                  </td>
                  <td>
                    {{ currentRemplacement.date_debut }}
                  </td>
                </tr>
                <tr class="d-flex justify-content-between">
                  <td>
                    <i class="fa fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date fin </span>
                  </td>
                  <td>
                    {{ currentRemplacement.date_fin }}
                  </td>
                </tr>
                <tr class="d-flex justify-content-between">
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Type absence</span>
                  </td>
                  <td>
                    {{ currentRemplacement.type_absence }}
                  </td>
                </tr>
                <tr class="d-flex justify-content-between">
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Type contrat</span>
                  </td>
                  <td>
                    {{ currentRemplacement.type_contrat }}
                  </td>
                </tr>
                <tr class="d-flex justify-content-between">
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Poste</span>
                  </td>
                  <td>
                    {{ currentRemplacement.poste }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="col-md-2 border-left py-3 px-1 bg-white d-flex flex-column align-items-center"
        >
          <h4 class="text-center">
            <i class="fa fa-info-circle text-custom-primary"></i> Commentaire
          </h4>
          <div class="mt-2">
            {{ currentRemplacement.commentaire }}
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-end bg-white mt-3 p-3">
        <div>
          <span class="mr-2"
            ><i class="far fa-user text-custom-primary"></i>
            <span class="font-weight-bold"> Auteur</span></span
          >
          <span> {{ currentRemplacement.auteur }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      title: 'Gestion des remplacements - Détails',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('remplacement', ['currentRemplacement']),
  },
  methods: {
    ...mapActions('remplacement', ['getRemplacement']),
    init() {
      this.getRemplacement({ id: this.$route.params.id });
    },
    viewEmploye(id) {
      return this.$router.push({
        name: 'rh_employe-show',
        params: {
          id,
        },
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
